import React from 'react'

import { Typography } from '@mui/material'

interface CardHeaderProps {
  text: string
}

export const GenericCardHeader: React.FC<CardHeaderProps> = ({ text }) => {
  return (
    <div
      style={{
        wordBreak: 'break-all',
        flexDirection: 'column',
        textAlign: 'center'
      }}
    >
      <Typography variant='subtitle2'>{text}</Typography>
    </div>
  )
}
